class TrackingComponentMockData {
  getIntervalOptions() {
		return {
			week: [
				{
                    value: '1 minute',
                    option: 1
                },
                {
                    value: '10 minutes',
                    option: 10,
                },
                {
                    value: '1 hour',
                    option: 60
                }
			],
			month: [
				{
                    value: '10 minutes',
                    option: 10
                },
                {
                    value: '1 hour',
                    option: 60,
                },
                {
                    value: '1 day',
                    option: (60*24)
                }
			],
			monthAbove: [
				{
                    value: '1 hour',
                    option: 60
				},
				{
                    value: '1 day',
                    option: (60*24)
                }
			]
		}
	}
}

export default TrackingComponentMockData;